export default __webpack_public_path__ + "static/media/001-turkey.d39074cf.svg";